module.exports = __webpack_public_path__ + "static/media/video-chat.e7ca8b10.svg";